const selector = ".purchase-widget-wrapper";
document.addEventListener("DOMContentLoaded", () => {
  const purchaseWidget = document.querySelector(selector);
  if (!purchaseWidget) {
    return;
  }
  purchaseWidget
    .querySelector(".purchase-widget__quantity__minus")
    .addEventListener("click", (e) => {
      e.preventDefault();
      updateQuantity("decrement");
    });
  purchaseWidget
    .querySelector(".purchase-widget__quantity__plus")
    .addEventListener("click", (e) => {
      e.preventDefault();
      updateQuantity("increment");
    });
  const upsells = purchaseWidget.querySelectorAll(".purchase-widget-upsell");
  upsells.forEach((upsell) => {
    upsell.addEventListener("click", (e) => {
      e.preventDefault();
      toggleUpsell(upsell.id);
    });
  });
  const addedUpsells = purchaseWidget.querySelectorAll(
    ".purchase-widget__added-upsell"
  );
  addedUpsells.forEach((addedUpsell) => {
    addedUpsell
      .querySelector(".purchase-widget__quantity__minus")
      .addEventListener("click", (e) => {
        e.preventDefault();
        upsellUpdateQuantity(addedUpsell.dataset.upsellId, "decrement");
      });
    addedUpsell
      .querySelector(".purchase-widget__quantity__plus")
      .addEventListener("click", (e) => {
        e.preventDefault();
        upsellUpdateQuantity(addedUpsell.dataset.upsellId, "increment");
      });
  });
  purchaseWidget
    .querySelector(".purchase__button")
    .addEventListener("click", (e) => {
      e.preventDefault();
      pwPurchase();
    });
  const uspInfoButtons = document.querySelectorAll("[data-usp-info-id]");
  uspInfoButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      toggleUSPInfo(button.dataset.uspInfoId);
    });
  });
  activateStickyButton();
});

const getDataset = () => {
  const purchaseWidget = document.querySelector(selector);
  if (!purchaseWidget) {
    return;
  }
  const price = parseInt(purchaseWidget.dataset.unitPrice);
  const compareAtPrice = parseInt(purchaseWidget.dataset.unitComparePrice);
  const quantity = parseInt(purchaseWidget.dataset.quantity);
  const total = parseInt(purchaseWidget.dataset.total);
  const compareAtTotal = parseInt(purchaseWidget.dataset.compareTotal);
  const variantId = parseInt(purchaseWidget.dataset.variantId);
  const buttonText = purchaseWidget.dataset.buttonText;
  return {
    price,
    compareAtPrice,
    quantity,
    total,
    compareAtTotal,
    variantId,
    buttonText,
  };
};

const updateQuantity = (type) => {
  const { price, compareAtPrice, quantity, total, compareAtTotal } =
    getDataset();
  const elem = document.querySelector(selector);
  const newQuantity =
    type === "increment" ? quantity + 1 : quantity > 1 ? quantity - 1 : 1;
  if (type === "increment" && newQuantity > 99) {
    return;
  }
  elem.dataset.quantity = newQuantity;
  elem.querySelector(".purchase-widget-quantity").innerHTML = newQuantity;
  const newTotal = total + price * newQuantity - price * quantity;
  const newCompareAtTotal =
    compareAtTotal + compareAtPrice * newQuantity - compareAtPrice * quantity;
  const stickyButtonTotal = document.querySelector(
    ".sticky-button-total__amount"
  );
  stickyButtonTotal.innerHTML = `£${(newTotal / 100).toFixed(2)}`;
  const stickyButtonItems = document.querySelector(".sticky-button-items");
  const addedUpsells = document.querySelectorAll(
    ".purchase-widget-upsell[data-added='true']"
  );
  const addedUpsellsQuantity = Array.from(addedUpsells).reduce(
    (acc, upsell) => acc + parseInt(upsell.dataset.quantity),
    0
  );
  const totalItems = newQuantity + addedUpsellsQuantity;
  stickyButtonItems.innerHTML = `${totalItems} Item${
    totalItems > 1 ? "s" : ""
  }`;
  elem.dataset.total = newTotal;
  elem.dataset.compareTotal = newCompareAtTotal;
  elem.querySelector(".price__total").innerHTML = `£${(newTotal / 100).toFixed(
    2
  )}`;
  elem.querySelector(".price__was").innerHTML = `£${(
    newCompareAtTotal / 100
  ).toFixed(2)}`;
};

const upsellUpdateQuantity = (id, type) => {
  const { price, compareAtPrice, quantity } = getUpsellDataset(id);
  const { total, compareAtTotal } = getDataset();
  const elem = document.getElementById(id);
  const addedElem = document.querySelector(
    ".purchase-widget__added-upsell[data-upsell-id='" + id + "']"
  );
  const purchaseWidget = document.querySelector(selector);
  const newQuantity = type === "increment" ? quantity + 1 : quantity - 1;
  if (type === "increment" && newQuantity > 99) {
    return;
  }
  if (newQuantity < 1) {
    toggleUpsell(id);
    return;
  }
  elem.dataset.quantity = newQuantity;
  addedElem.querySelector(".purchase-widget-quantity").innerHTML = newQuantity;
  const newTotal = total + price * newQuantity - price * quantity;
  const newCompareAtTotal =
    compareAtTotal + compareAtPrice * newQuantity - compareAtPrice * quantity;
  const stickyButtonTotal = document.querySelector(
    ".sticky-button-total__amount"
  );
  stickyButtonTotal.innerHTML = `£${(newTotal / 100).toFixed(2)}`;
  const stickyButtonItems = document.querySelector(".sticky-button-items");
  const addedUpsells = document.querySelectorAll(
    ".purchase-widget-upsell[data-added='true']"
  );
  const addedUpsellsQuantity = Array.from(addedUpsells).reduce(
    (acc, upsell) => acc + parseInt(upsell.dataset.quantity),
    0
  );
  const { quantity: baseQuantity } = getDataset();
  const totalItems = baseQuantity + addedUpsellsQuantity;
  stickyButtonItems.innerHTML = `${totalItems} Item${
    totalItems > 1 ? "s" : ""
  }`;
  purchaseWidget.dataset.total = newTotal;
  purchaseWidget.dataset.compareTotal = newCompareAtTotal;
  purchaseWidget.querySelector(".price__total").innerHTML = `£${(
    newTotal / 100
  ).toFixed(2)}`;
  purchaseWidget.querySelector(".price__was").innerHTML = `£${(
    newCompareAtTotal / 100
  ).toFixed(2)}`;
};

const getUpsellDataset = (id) => {
  const upsell = document.getElementById(id);
  if (!upsell) {
    return;
  }
  const price = parseInt(upsell.dataset.unitPrice);
  const compareAtPrice = parseInt(upsell.dataset.unitComparePrice);
  const variantId = parseInt(upsell.dataset.id);
  const added = upsell.dataset.added === "true";
  const quantity = parseInt(upsell.dataset.quantity);
  return {
    price,
    compareAtPrice,
    variantId,
    added,
    quantity,
  };
};

const toggleUpsell = (id) => {
  const { price, compareAtPrice, added } = getUpsellDataset(id);
  const { total, compareAtTotal } = getDataset();
  const elem = document.getElementById(id);
  const purchaseWidget = document.querySelector(selector);
  elem.dataset.added = !added;
  const addedUpsells = purchaseWidget.querySelector(
    ".purchase-widget__added-upsells"
  );
  const addedUpsellsVisisble = addedUpsells.dataset.visible === "true";
  const anyAddedUpsells =
    purchaseWidget.querySelectorAll(
      ".purchase-widget-upsell[data-added='true']"
    ).length > 0;
  const addedUpsell = document.querySelector(
    ".purchase-widget__added-upsell[data-upsell-id='" + id + "']"
  );
  const stickyButtonTotal = document.querySelector(
    ".sticky-button-total__amount"
  );
  const stickyButtonItems = document.querySelector(".sticky-button-items");
  const activeUpsells = document.querySelectorAll(
    ".purchase-widget-upsell[data-added='true']"
  );
  const activeUpsellsQuantity = Array.from(activeUpsells).reduce(
    (acc, upsell) => acc + parseInt(upsell.dataset.quantity),
    0
  );
  const { quantity: baseQuantity } = getDataset();
  const totalItems = baseQuantity + activeUpsellsQuantity;
  stickyButtonItems.innerHTML = `${totalItems} Item${
    totalItems > 1 ? "s" : ""
  }`;
  switch (added) {
    case true:
      const newTotal = total - price;
      const newCompareAtTotal = compareAtTotal - compareAtPrice;
      purchaseWidget.dataset.total = newTotal;
      purchaseWidget.dataset.compareTotal = newCompareAtTotal;
      stickyButtonTotal.innerHTML = `£${(newTotal / 100).toFixed(2)}`;
      purchaseWidget.querySelector(".price__total").innerHTML = `£${(
        newTotal / 100
      ).toFixed(2)}`;
      purchaseWidget.querySelector(".price__was").innerHTML = `£${(
        newCompareAtTotal / 100
      ).toFixed(2)}`;
      elem.classList.remove("pw-added");
      elem.querySelector(".purchase-widget-upsell__button").innerHTML =
        '                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="0.712402" y="5.84021" width="12.2951" height="1.72131" fill="white"/><rect x="5.87671" y="12.9713" width="12.2951" height="1.72131" transform="rotate(-90 5.87671 12.9713)" fill="white"/></svg>';
      if (addedUpsellsVisisble && !anyAddedUpsells) {
        addedUpsells.dataset.visible = "false";
        addedUpsells.style.maxHeight = "0";
        addedUpsells.style.marginBottom = "0";
      }
      addedUpsell.style.display = "none";
      break;
    case false:
      const newTotalAdd = total + price;
      const newCompareAtTotalAdd = compareAtTotal + compareAtPrice;
      purchaseWidget.dataset.total = newTotalAdd;
      purchaseWidget.dataset.compareTotal = newCompareAtTotalAdd;
      stickyButtonTotal.innerHTML = `£${(newTotalAdd / 100).toFixed(2)}`;
      purchaseWidget.querySelector(".price__total").innerHTML = `£${(
        newTotalAdd / 100
      ).toFixed(2)}`;
      purchaseWidget.querySelector(".price__was").innerHTML = `£${(
        newCompareAtTotalAdd / 100
      ).toFixed(2)}`;
      elem.classList.add("pw-added");
      elem.querySelector(".purchase-widget-upsell__button").innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none"><path d="M13.4732 2.41747L13.4733 2.41744C13.6689 2.22176 13.7788 1.95638 13.7788 1.67968C13.7788 1.40298 13.6689 1.1376 13.4733 0.941916L13.4732 0.941857C13.2775 0.746228 13.0121 0.63633 12.7354 0.63633C12.4587 0.63633 12.1934 0.746228 11.9977 0.941857L11.9976 0.941886L5.41296 7.52657L2.68221 4.79582L2.68224 4.79579L2.67883 4.7925C2.48202 4.60241 2.21843 4.49723 1.94483 4.49961C1.67122 4.50199 1.40949 4.61173 1.21602 4.80521C1.02254 4.99869 0.912795 5.26041 0.910418 5.53402C0.90804 5.80762 1.01322 6.07122 1.20331 6.26803L1.20328 6.26806L1.20663 6.27141L4.67517 9.73995L4.6752 9.73998C4.87089 9.93561 5.13626 10.0455 5.41296 10.0455C5.68966 10.0455 5.95504 9.93561 6.15073 9.73998L6.15076 9.73995L13.4732 2.41747Z" fill="white" stroke="white" stroke-width="0.545455"/></svg>';
      addedUpsell.style.display = "grid";
      if (!addedUpsellsVisisble) {
        addedUpsells.style.maxHeight = "1000px";
        addedUpsells.dataset.visible = "true";
        addedUpsells.style.marginBottom = "15px";
      }
      purchaseWidget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      break;
  }
};

const pwPurchase = () => {
  if (window.addItemBusy) {
    return;
  }
  window.addItemBusy = true;
  const purchaseWidgetDataset = getDataset();
  if (!purchaseWidgetDataset) {
    return;
  }
  const { quantity, variantId } = purchaseWidgetDataset;
  const upsellItems = [];
  const purchaseWidget = document.querySelector(selector);
  const upsells = purchaseWidget.querySelectorAll(".purchase-widget-upsell");
  upsells.forEach((upsell) => {
    if (upsell.dataset.added === "true") {
      upsellItems.push({
        id: upsell.id,
        quantity: parseInt(upsell.dataset.quantity),
      });
    }
  });
  const itemsData = {
    items: [
      {
        id: variantId,
        quantity: quantity,
      },
      ...upsellItems,
    ],
  };
  fetch("/cart/clear.js", {
    method: "POST",
  }).then(() => {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(itemsData),
    })
      .then((response) => {
        if (response.ok) {
          window.location.href = "/checkout";
        } else {
          console.error("Error adding item to cart", response);
        }
      })
      .catch((error) => {
        console.error("Error adding item to cart", error);
      })
      .finally(() => {
        window.addItemBusy = false;
      });
  });
};

const toggleUSPInfo = (id) => {
  const uspInfo = document.getElementById(id);
  const uspInfoVisible = uspInfo.dataset.visible === "true";
  if (uspInfoVisible) {
    uspInfo.style.maxHeight = "0";
    setTimeout(() => {
      uspInfo.style.paddingTop = "0";
    }, 500);
    uspInfo.dataset.visible = "false";
  } else {
    uspInfo.style.maxHeight = "1000px";
    uspInfo.style.paddingTop = "15px";
    uspInfo.dataset.visible = "true";
  }
};

activateStickyButton = () => {
  const { buttonText, total } = getDataset();
  const container = document.createElement("div");
  container.classList.add("sticky-button-container");
  const infoContainer = document.createElement("div");
  infoContainer.classList.add("sticky-button-info");
  const itemsContainer = document.createElement("div");
  itemsContainer.classList.add("sticky-button-items");
  itemsContainer.innerHTML = "1 Item";
  const totalContainer = document.createElement("div");
  totalContainer.classList.add("sticky-button-total");
  const totalAmount = document.createElement("div");
  totalAmount.classList.add("sticky-button-total__amount");
  totalAmount.innerHTML = `£${(total / 100).toFixed(2)}`;
  totalContainer.appendChild(totalAmount);
  infoContainer.appendChild(itemsContainer);
  infoContainer.appendChild(totalContainer);
  container.appendChild(infoContainer);
  const buttonContainer = document.createElement("div");
  buttonContainer.classList.add("sticky-button");
  const button = document.createElement("button");
  button.classList.add("sticky-button__button");
  button.innerHTML = buttonText;
  button.addEventListener("click", (e) => {
    e.preventDefault();
    pwPurchase();
  });
  buttonContainer.appendChild(button);
  container.appendChild(buttonContainer);
  document.body.appendChild(container);
  const purchaseWidgetPriceWrapper = document.querySelector(
    ".purchase__price-wrapper"
  );
  if (!purchaseWidgetPriceWrapper) {
    return;
  }
  document.body.onscroll = () => {
    if (
      window.scrollY >
      purchaseWidgetPriceWrapper.offsetTop +
        purchaseWidgetPriceWrapper.offsetHeight
    ) {
      container.style.opacity = 1;
      container.style.visibility = "visible";
    } else {
      container.style.opacity = 0;
      container.style.visibility = "hidden";
    }
  };
  document
    .getElementById("shopify-section-footer")
    .classList.add("sticky-margin");
};
